<template>
  <div>
    <div
      class="modal fade"
      :class="{ show: show }"
      :style="{ display: show ? 'block' : 'none' }"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{pageContent.modal_title}}</h5>
            <button
              type="button"
              class="btn-close"
              @click="closeModal"
            ></button>
          </div>
          <div class="modal-body">
            <p>{{pageContent.modal_intro}}</p>
            <small>{{pageContent.modal_subtext}}</small>
            <ul class="list-group">
              <li class="list-group-item">
                <a
                  href="/assets/teacher-resources/Florida Department of Education - ESOL Lesson Plan Template.pdf"
                  target="_blank"
                  download
                >
                {{pageContent.template_1}}
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="/assets/teacher-resources/Lecture Notes Template.pdf"
                  target="_blank"
                  download
                >
                {{pageContent.template_2}}
                </a>
              </li>
              <li class="list-group-item">
                <a
                  href="/assets/teacher-resources/Lesson Plan Template for Instructors using the FDOE Adult ESOL Framework.pdf"
                  target="_blank"
                  download
                >
                {{pageContent.template_3}}
                </a>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              {{pageContent.modal_close_button}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    pageContent: {
      type: Object,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
</style>
